import { load } from '@helpers/google';
import svgMarker from '@img/icons/marker-circle.svg';
import { locations } from '@redux/slices/locations';
import { useAppDispatch, useAppSelector } from '@redux/store';
import once from 'lodash/once';
import * as React from 'react';
import S from './MapArea.styles';
const MapArea = () => {
    const refMapContainer = React.useRef(null);
    const dispatch = useAppDispatch();
    const state = useAppSelector((state) => state.locations);
    // Destructure state as needed.
    const items = state.apiData?.items ?? [];
    // Combine item ids for dependency array.
    const ids = items.map((item) => item.id).join(',');
    React.useEffect(() => {
        doAsync();
        async function doAsync() {
            if (!refMapContainer.current) {
                return;
            }
            if (!items.length) {
                return;
            }
            // Ensure SDK is loaded.
            const googleApi = await load();
            // Create new map instance.
            const map = new googleApi.maps.Map(refMapContainer.current, {
                center: { lat: 0, lng: 0 },
                zoom: 13,
            });
            // Create map bounds for markers.
            const bounds = new googleApi.maps.LatLngBounds();
            // Check for selected location.
            const selectedIndex = items.findIndex((item) => item.id === state.selectedLocationId);
            if (selectedIndex >= 0) {
                const selectedLocation = items[selectedIndex];
                new googleApi.maps.Marker({
                    icon: svgMarker,
                    label: {
                        color: '#fff',
                        fontFamily: 'Brandon Grotesque',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        text: (selectedIndex + 1).toString(),
                    },
                    map,
                    position: selectedLocation.position,
                });
                bounds.extend(selectedLocation.position);
            }
            else {
                // Create markers and extend bounds.
                items.forEach((item, index) => {
                    const marker = new googleApi.maps.Marker({
                        icon: svgMarker,
                        label: {
                            color: '#fff',
                            fontFamily: 'Brandon Grotesque',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            text: (index + 1).toString(),
                        },
                        map,
                        position: item.position,
                    });
                    bounds.extend(item.position);
                    marker.addListener('click', () => {
                        dispatch(locations.actions.selectLocation(item.id));
                    });
                });
            }
            // Update map to fit marker bounds.
            if (!bounds.isEmpty()) {
                map.addListener('bounds_changed', once(() => {
                    // Enforce max zoom level after fitbounds is called.
                    const zoom = map.getZoom();
                    if (zoom && zoom > 13) {
                        map.setZoom(13);
                    }
                }));
                map.fitBounds(bounds);
            }
        }
    }, [ids, state.selectedLocationId]);
    if (!items) {
        return null;
    }
    return React.createElement(S.Container, { ref: refMapContainer });
};
export default MapArea;
